import { useState, useRef, useEffect } from "react";

import * as Style from "./style";

const preventDefaults = (e) => {
  e.preventDefault();
  e.stopPropagation();
};

function DragAndDrop({ id, onFileUpload, disabled }) {
  const [isHighlighted, setIsHighlighted] = useState(false);
  const inputRef = useRef(null);

  const onDragEnterOverHandler = (e) => {
    preventDefaults(e);
    setIsHighlighted(true);
  };

  const onDragLeaveHandler = (e) => {
    preventDefaults(e);
    setIsHighlighted(false);
  };

  const onDropHandler = (e) => {
    preventDefaults(e);
    setIsHighlighted(false);
    onFileUpload(e.dataTransfer.files[0]);
  };

  const onChangeHandler = (e) => {
    if (e.target.files) {
      onFileUpload(e.target.files[0]);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  }, []);

  return (
    <form
      onDragEnter={onDragEnterOverHandler}
      onDragOver={onDragEnterOverHandler}
      onDragLeave={onDragLeaveHandler}
      onDrop={onDropHandler}
    >
      <Style.Input
        id={id}
        type="file"
        accept="text/plain, application/zip"
        ref={inputRef}
        onChange={onChangeHandler}
        disabled={!disabled}
      />
      <Style.Label htmlFor={id} isHighlighted={isHighlighted}>
        <Style.P>
          Click here to upload a file or drag and drop it onto the dashed region
          (supported formats: <Style.Extension>txt</Style.Extension>,{" "}
          <Style.Extension>zip</Style.Extension>)
        </Style.P>
      </Style.Label>
    </form>
  );
}

export default DragAndDrop;
